import React from 'react'

export default function TableSelector({ tables, value, onSelect }) {
  // Group tables by area (if areas exist)
  const hasAreas = tables.some(t => t.area)

  const grouped = hasAreas
    ? tables.reduce((acc, table) => {
        const area = table.area || 'Other'
        if (!acc[area]) acc[area] = []
        acc[area].push(table)
        return acc
      }, {})
    : null

  return (
    <select
      value={value || ''}
      onChange={(e) => {
        const selected = tables.find(t => t.qr_code === e.target.value)
        onSelect(selected || null)
      }}
      className="w-full px-4 py-3 rounded-lg border-0 bg-white text-gray-900 font-medium text-center focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
      aria-label="Select your table"
    >
      <option value="">Select your table</option>
      {grouped ? (
        Object.entries(grouped).map(([area, areaTables]) => (
          <optgroup key={area} label={area}>
            {areaTables.map(table => (
              <option key={table.qr_code} value={table.qr_code}>
                {table.display_name}
              </option>
            ))}
          </optgroup>
        ))
      ) : (
        tables.map(table => (
          <option key={table.qr_code} value={table.qr_code}>
            {table.display_name}
          </option>
        ))
      )}
    </select>
  )
}
